import { Button, useColorModeValue } from "@chakra-ui/react";
import { PrimaryButton } from ".";

interface ProceedCancelButtonsProps {
  handleSubmit: () => void;
  onClose?: () => void;
  proceedText: string;
  proceedDisabled?: boolean;
  isLoading?: boolean;
  loadingText?: string;
}

export default function ProceedCancelButtons({
  handleSubmit,
  onClose,
  proceedText,
  proceedDisabled,
  isLoading = false,
  loadingText = "Submitting",
}: ProceedCancelButtonsProps) {
  const closeBtnColor = useColorModeValue("inherit", "gray.50");
  return (
    <>
      {onClose && (
        <Button
          onClick={onClose}
          variant="outline"
          color={closeBtnColor}
          colorScheme="gray"
          mr={1}
        >
          Cancel
        </Button>
      )}
      <PrimaryButton onClick={handleSubmit} isLoading={isLoading} loadingText={loadingText} isDisabled={proceedDisabled}>
        {proceedText}
      </PrimaryButton>
    </>
  );
}
